/**
 * Wrapper pour les backgrounds avec couleur de branding pour les formulaires publics (référent + candidat)
 */
import { useReferentBrandingColors } from '@/hooks/useReferentBrandingColors';

interface BrandingSettings {
  enabled: boolean;
  logo_url?: string;
  primary_color?: string;
}

interface BrandedBackgroundProps {
  children: React.ReactNode;
  opacity?: number;
  className?: string;
  branding?: BrandingSettings | null;
  withBorder?: boolean;
}

export const BrandedBackground = ({ 
  children, 
  opacity = 0.1, 
  className = 'p-4 rounded-lg', 
  branding,
  withBorder = false
}: BrandedBackgroundProps) => {
  const colors = useReferentBrandingColors(branding);
  
  return (
    <div 
      className={className}
      style={{ 
        backgroundColor: colors.primaryWithOpacity(opacity),
        ...(withBorder && { 
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: colors.primary 
        })
      }}
    >
      {children}
    </div>
  );
};